import React, { useState } from 'react'

// Styling
import { IoCallOutline, IoMailOutline } from 'react-icons/io5'
import Modal from '../Modal/Modal'
import './ContactOptions.css'


const ContactOptions = () => {

    const [modal, setModal] = useState(false);
    const [modalId, setModalId] = useState('');

    const openModal = () => {
        setModal(!modal);
    }

    return (
        <div className='container'>
            <section>
                <div className="card__container">
                    <div className="card">
                        <div className="contact__card-header">
                            <span><IoCallOutline className='icon-xl mb-1' /></span>
                            <h2>Phone</h2>
                        </div>
                        <p>Naš tim je za dostupan za bilo koju vrstu pomoći.</p>

                        <button className="btn"
                            onClick={() =>
                                [
                                    openModal(),
                                    setModalId('phone')
                                ]
                            }
                        >Contact Us
                        </button>
                    </div>

                    <div className="card">
                        <div className="contact__card-header" >
                            <span><IoMailOutline className='icon-xl mb-1' /></span>
                            <h2>Email</h2>
                        </div>
                        <p>Popunite formu i kontaktirajte nas putem email-a.</p>

                        <button className="btn"
                            onClick={() =>
                                [
                                    openModal(),
                                    setModalId('mail')
                                ]
                            }

                        >Contact Us</button>
                    </div>

                    {/*Third card with Appointments*/}
                    {/* <div className="contact__card">
                    <div className="contact__card--header">
                        <ion-icon name="calendar-clear-outline" className="icon"></ion-icon>
                        <h2>Appointments</h2>
                    </div>
                    <p>Book a virtual or an in-store appointment with one of our skilled advisors.</p>
                      <button id="modalBtnMail" className="btn"
                            onClick={() =>
                                [
                                    openModal('apointment'),
                                    setModalId('apointment')
                                ]
                            }

                        >Contact Us</button>

                </div>*/}
                </div>
            </section>

            <Modal modal={modal} setModal={setModal} modalId={modalId} />
        </div>
    )
}

export default ContactOptions